import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { theme } from '../../constants/theme.mjs';
import '../../contexts/MenuContext/mapping.mjs';
import '../../hooks/index.mjs';
import '../Button/index.mjs';
import './translations/index.mjs';
import { useTranslation } from '../../hooks/useTranslation.mjs';
import { Language } from '../../types/constants.mjs';
import EN_TRANSLATION from './translations/en.json.mjs';
import { Button as Button$1 } from '../Button/Button.mjs';
"use strict";
const MicrositeBuyButton = ({
  label,
  href,
  className
}) => {
  const {
    formatMessage
  } = useTranslation({
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ar]: () => import('./translations/ar.json.mjs').then(res => res.default),
      [Language.Ca]: () => import('./translations/ca.json.mjs').then(res => res.default),
      [Language.Cs]: () => import('./translations/cs.json.mjs').then(res => res.default),
      [Language.Da]: () => import('./translations/da.json.mjs').then(res => res.default),
      [Language.Nl]: () => import('./translations/nl.json.mjs').then(res => res.default),
      [Language.Fr]: () => import('./translations/fr.json.mjs').then(res => res.default),
      [Language.De]: () => import('./translations/de.json.mjs').then(res => res.default),
      [Language.El]: () => import('./translations/el.json.mjs').then(res => res.default),
      [Language.It]: () => import('./translations/it.json.mjs').then(res => res.default),
      [Language.Ja]: () => import('./translations/ja.json.mjs').then(res => res.default),
      [Language.Ko]: () => import('./translations/ko.json.mjs').then(res => res.default),
      [Language.No]: () => import('./translations/no.json.mjs').then(res => res.default),
      [Language.Pl]: () => import('./translations/pl.json.mjs').then(res => res.default),
      [Language.PtPt]: () => import('./translations/pt-PT.json.mjs').then(res => res.default),
      [Language.PtBr]: () => import('./translations/pt-BR.json.mjs').then(res => res.default),
      [Language.EsMx]: () => import('./translations/es-MX.json.mjs').then(res => res.default),
      [Language.Sv]: () => import('./translations/sv.json.mjs').then(res => res.default),
      [Language.Tr]: () => import('./translations/tr.json.mjs').then(res => res.default),
      [Language.Zh]: () => import('./translations/zh-Hans.json.mjs').then(res => res.default),
      [Language.Tw]: () => import('./translations/zh-Hant-TW.json.mjs').then(res => res.default),
      [Language.Ru]: () => import('./translations/ru.json.mjs').then(res => res.default),
      [Language.EsEs]: () => import('./translations/es-ES.json.mjs').then(res => res.default)
    }
  });
  return /* @__PURE__ */jsx(Wrap, {
    children: /* @__PURE__ */jsx(Button, {
      variant: "primary",
      anchor: true,
      href,
      className,
      children: label ? label : formatMessage("label")
    })
  });
};
const Wrap = styled.div`
  display: flex;
  justify-content: center;
`;
const Button = styled(Button$1)`
  line-height: 20px;
  padding: 10px 15px;
  font-weight: ${theme.fontWeight.bold};
  display: inline-flex;

  &:focus,
  &:hover {
    text-decoration: none;
    color: ${theme.colors.white};
  }
`;
export { MicrositeBuyButton };
//# sourceMappingURL=MicrositeBuyButton.mjs.map
